import { createSlice, PayloadAction } from "@reduxjs/toolkit";

export enum OlkyPassProTab {
  Level = "Level",
  Documents = "Documents",
  Emails = "Emails",
  Address = "Address",
  Mobiles = "Mobiles",
  Ibans = "Ibans",
  PublicVisibility = "PublicVisibility"
}

export const COMPANY_ONBOARDING_SLICE_INITIAL = {
  olkypassPassProTab: OlkyPassProTab.Level,
  addAlias: false
} satisfies CompanyOnboardingState as CompanyOnboardingState;

type CompanyOnboardingState = {
  olkypassPassProTab: OlkyPassProTab;
  addAlias: boolean;
};

export const companyonboardingSlice = createSlice({
  name: "companyOnboarding",
  initialState: COMPANY_ONBOARDING_SLICE_INITIAL,

  reducers: {
    setOlkypassPassProTab: (state, action: PayloadAction<OlkyPassProTab>) => {
      state.olkypassPassProTab = action.payload;
    },
    setAddAlias: (state, action: PayloadAction<boolean>) => {
      state.addAlias = action.payload;
    },
    setOlkypassPassProTabAndAddAlias: (state, action: PayloadAction<OlkyPassProTab>) => {
      state.olkypassPassProTab = action.payload;
      state.addAlias = true;
    }
  }
});

export const { setOlkypassPassProTab, setAddAlias, setOlkypassPassProTabAndAddAlias } =
  companyonboardingSlice.actions;
